import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/store/store-cart-shell.tsx");
